// Helper compartilhado para o gotcha de RLS em UPDATE via supabase-js:
// um UPDATE bloqueado pela policy retorna sucesso (sem `error`) com ZERO
// linhas afetadas — nao lanca excecao sozinho. Todo `.update(...)` deste
// projeto usa `.select(...)` em seguida e passa o resultado por aqui antes de
// tratar a escrita como bem-sucedida.
export class RlsBlockedError extends Error {
  constructor(context: string) {
    super(
      `Nenhuma linha foi afetada em "${context}". A política de segurança (RLS) ` +
        "bloqueou a escrita, ou o registro não existe mais.",
    );
    this.name = "RlsBlockedError";
  }
}

export function assertRowsAffected<T>(
  data: T[] | null | undefined,
  context: string,
): T[] {
  if (!data || data.length === 0) {
    throw new RlsBlockedError(context);
  }
  return data;
}

export function supabaseErrorMessage(error: { message: string } | null): never {
  throw new Error(error?.message ?? "Erro desconhecido de banco de dados.");
}
